import { browserExtensionClient } from 'clients/BrowserExtensionClient/BrowserExtensionClient';
import { useContext, useEffect } from 'react';
import {
  getIsLoggedInFromBrowserExtension,
  getTokenFromBrowserExtension,
} from 'services/browser-extension/getTokenFromBrowserExtension';
import { AuthContext } from 'shared/legacy/contexts/AuthContext';
import { useCurrentUserQuery } from 'shared/legacy/hooks/useCurrentUserQuery';
import { useIndeedConfig } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedConfig';
import { sendIndeedConfig } from 'shared/legacy/hooks/useBrowserExtension/indeed/sendIndeedConfig';
import { BrowserExtensionInfoStatus, useBrowserExtensionStatusQuery } from './useBrowserExtensionStatusQuery';
import { useUpdateExtensionSettings } from './useUpdateExtensionSettings';

export const useBrowserExtensionSync = () => {
  const { activeToken } = useContext(AuthContext);
  const { data: currentUser } = useCurrentUserQuery();
  const browserExtensionStatusQuery = useBrowserExtensionStatusQuery();
  const indeedConfig = useIndeedConfig();

  const isExtensionActive = browserExtensionStatusQuery.data?.status === BrowserExtensionInfoStatus.Active;

  const updateUserStateChange = async () => {
    browserExtensionClient.sendMessage('userStateChanged', {
      user: currentUser,
      isLoggedIn: true,
      token: activeToken,
    });
    sendIndeedConfig(activeToken!, indeedConfig.getCurrentValue());
  };

  useEffect(() => {
    if (activeToken && currentUser && isExtensionActive) {
      getTokenFromBrowserExtension().then((token) => {
        if (!token || token !== activeToken) {
          updateUserStateChange();
        } else {
          getIsLoggedInFromBrowserExtension().then((isLoggedIn) => {
            if (isLoggedIn !== '1') {
              updateUserStateChange();
            }
          });
        }
      });
    }
  }, [activeToken, currentUser, isExtensionActive]);

  // Re-sync Indeed config whenever the user's Indeed login state changes
  // (e.g. disconnect → reconnect, ctk rotation, page reload after cache is warm)
  useEffect(() => {
    if (activeToken && isExtensionActive && !indeedConfig.isInitialLoading) {
      sendIndeedConfig(activeToken, indeedConfig);
    }
  }, [indeedConfig.isLoggedIn, isExtensionActive, activeToken]);

  useUpdateExtensionSettings();

  return { updateUserStateChange };
};
